import { Inject, Injectable } from '@angular/core';
import { APP_STORE_CONFIG_TOKEN } from '@ddt-web/config';
import { InjectConfig, SharedConfigKey } from '@ddt-web/config-layer';
import { AppStoreConfig } from '@ddt-web/data-service';
import { FundPreferenceStoreService } from '@ddt-web/fund-preferences';
import { StoreService } from '@ddt-web/store-service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { FundStatusInteractionGroupConfig } from '../models/fund-status-interaction-config.interface';
import { FUND_STATUS_INTERACTIONS_STORE } from '../models/fund-status-interaction.constants';
import { FundStatusInteractionData, FundStatusInteractions } from '../models/fund-status-interaction.interface';

@Injectable({
	providedIn: 'root'
})
export class FundStatusInteractionStoreService extends FundPreferenceStoreService {
	@InjectConfig(SharedConfigKey.SUPPORTED_FUND_STATUS_INTERACTIONS) private readonly supportedFundInteractions: FundStatusInteractionGroupConfig[];

	constructor(@Inject(APP_STORE_CONFIG_TOKEN) protected storeConfig: AppStoreConfig, protected storeService: StoreService) {
		super(storeConfig, storeService);
	}

	public setFundStatusInteraction(fundStatusInteractions: FundStatusInteractionData[]): void {
		this.setPreferenceData(fundStatusInteractions, FUND_STATUS_INTERACTIONS_STORE);
	}

	public getAllFundStatusInteractions(): Observable<FundStatusInteractions> {
		return this.getAll<FundStatusInteractions, FundStatusInteractionData>(FUND_STATUS_INTERACTIONS_STORE);
	}

	public getFundStatusInteractionsById(fundId: string): Observable<FundStatusInteractionData> {
		return this.getPreferencesById<FundStatusInteractionData>(fundId, FUND_STATUS_INTERACTIONS_STORE).pipe(
			map((statusInteractionsById: FundStatusInteractions) => statusInteractionsById?.[fundId] || ({ interactionType: 'default' } as FundStatusInteractionData))
		);
	}

	protected override getValidFundPreferences<FundStatusInteractionData>(fundStatusInteractions: FundStatusInteractionData[]): FundStatusInteractionData[] {
		const validInteractions: string[] = this.supportedFundInteractions.reduce((interactionIds: string[], group: FundStatusInteractionGroupConfig) => {
			const ids = group.interactions.map(interaction => interaction.id);
			return [...interactionIds, ...ids];
		}, []);

		return fundStatusInteractions.filter(fundStatusInteractionData => validInteractions.includes(fundStatusInteractionData['interactionType']));
	}
}
